<template>
    <div class="row">
      <modal :show.sync="addClockForm"
             body-classes="p-0"
             modal-classes="modal-dialog-top modal-sm"
             :scrollToBottom="false"
             :centered="false">
        <add-clock-panel :dates="dates" @add-clock="addClock"></add-clock-panel>
      </modal>
      <div class="col-md-12">
        <div class="row">
          <transition name="view" appear enter-active-class="animated fadeIn delay">
            <div class="col-md-12">
              <projects-filter :projects="projects" :curProject="project" @change-project="changeProject"></projects-filter>
              <progress-bar :value="progressValue"></progress-bar>
            </div>
          </transition>
        </div>
        <div class="row" style="margin-top: -25px">
          <div class="col-md-12">
            <transition name="view" appear enter-active-class="animated zoomIn delay">
              <buttons-block @start-clock="clock('start')" @stop-clock="clock('stop')" @add-clock="clock('add')" :timeStarted="timeNotDone" ></buttons-block>
            </transition>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <transition name="view" appear enter-active-class="animated flipInX delay2">
              <clocks-total-values :totals="totalClocksData"></clocks-total-values>
            </transition>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <transition name="view" appear enter-active-class="animated fadeInUp delay3">
              <clocks-values :values="clocks"></clocks-values>
            </transition>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {url} from "../plugins/axios";
    import ProjectsFilter from "../components/Filters/Projects";
    import ProgressBar from "../components/Progress";
    import axios from "axios";
    import {setCookie} from "../plugins/axios";
    import {getCookie} from "../plugins/axios";
    import ButtonsBlock from "./Clocks/ButtonBlock";
    import NotificationTemplate from "./Notifications/NotificationTemplate";
    import Modal from '../components/Modal'
    import AddClockPanel from "./Clocks/AddClockPanel";
    import ClocksTotalValues from "./Clocks/ClocksTotalValues";
    import ClocksValues from "./Clocks/ClocksValues";
    export default {
      name: "Clocks",
      components: {ClocksValues, ClocksTotalValues, AddClockPanel, ButtonsBlock, ProjectsFilter, ProgressBar,  Modal},
      data(){
          return{
            projects:{},
            project: parseInt(getCookie('Project-id')),
            progressValue:0,
            addClockForm: false,
            dates: {date:null, time:{start: null, end: null},},
            clocks: [], totalClocksData: {},
            timeNotDone:false,
          }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        changeProject(value){
          if (value  > 0){
            axios
              .put(url + 'update-employees/',
                {data: {'employee': {'project_id': value}}},
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success', 'Project was changed');
                  setCookie('Project-id', value, 1)
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.notifyVue('danger', response.data.error);
                  }
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
              });
          }
          else{
            if (value  < 0){this.$router.push('/projects-settings');}
          }
        },
        getProjectForFilter(){
          axios
            .get(url + 'projects-short/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.projects = response.data.result
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });

        },
        clock(action){
          let today = new Date();
          let dateYMD = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+(today.getDate());
          let fullDate = dateYMD + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
          if (action === 'start'){
            this.timeNotDone = true;
            axios
              .post(url + 'start-clock/',
                {data: {"fullDate":fullDate}},
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success', 'Clock was started');
                  this.getWorkingClocks();
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.notifyVue('danger', response.data.error);
                    this.timeNotDone = false;
                  }
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
                this.timeNotDone = false;
              });
          }
          else if(action === 'stop'){
            this.timeNotDone = false;
            axios
              .put(url + 'stop-clock/',
                {data: {"fullDate":fullDate}},
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success', 'Clock was stopped');
                  this.getWorkingClocks();
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.timeNotDone = true;
                    this.notifyVue('danger', response.data.error);
                  }
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
                this.timeNotDone = true;
              });
          }
          else if(action === 'add'){
            this.addClockForm = true
          }
          else{}
        },
        addClock(){
          this.addClockForm = false;
          if (this.dates.time.start === '24:00'){
            this.dates.time.start = '00:00:01';
          }
          if (this.dates.time.end === '24:00'){
            this.dates.time.end = '23:59:59';
          }
          this.dates.time.start = this.dates.date + ' ' + this.dates.time.start;
          this.dates.time.end = this.dates.date   + ' ' + this.dates.time.end;
          axios
            .post(url + 'add-clock/',
              {data: {"time_start":this.dates.time.start, "time_end":this.dates.time.end}},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.notifyVue('success', 'Clock was added');
                this.dates.time.start = "07:00 am";
                this.dates.time.end   = "05:00 pm";
                this.getWorkingClocks();
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger', response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        countWage(start,end,wage){
          if (end === null){
            return 0
          }else{
            let date1 = new Date(start.split('-').join('/'));
            let date2 = new Date(end.split('-').join('/'));
            let dif = new Date(date2 - date1);
            wage = parseInt(wage);
            return Math.floor(dif.getUTCHours()*wage + (dif.getUTCMinutes()*wage)/60 + (dif.getUTCSeconds()*wage)/3600);
          }
        },
        getTime(time, dif){

          let h = parseInt(time.split(":")[0]) + dif.getUTCHours();
          let m = parseInt(time.split(":")[1]) + dif.getUTCMinutes();
          let s = parseInt(time.split(":")[2]) + dif.getUTCSeconds();

          m = m + Math.trunc(s/60);
          s = s % 60;
          h = h + Math.trunc(m/60);
          m = m % 60;

          return h+':'+m+':'+s;
        },
        getWorkingClocks(){
          axios
            .get(url + 'employees-clocks/myself/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                let totalTable=[{items: ['0:0:0', '0:0:0', '0:0:0', ]},{items: [0, 0, 0, ]}];
                this.clocks = response.data.result;
                if (this.clocks !== null){
                  const last = this.clocks[Object.keys(this.clocks)[Object.keys(this.clocks).length - 1]];
                  const today = new Date().toLocaleDateString();
                  const lastDate = new Date(last.date.split('-').join('/') + ' 00:00:01').toLocaleDateString();
                  this.timeNotDone = last.time_end === null && lastDate === today;
                }

                for(let row in this.clocks) {
                  let nextLine = this.clocks[row];
                  if (nextLine.time_end !== null){
                    let temp = this.countWage(nextLine.time_start,nextLine.time_end,nextLine.rate);
                    let date1 = new Date(nextLine.time_start.split('-').join('/'));
                    let date2 = new Date(nextLine.time_end.split('-').join('/'));
                    let dif = new Date(date2 - date1);
                    totalTable[0].items[0] = this.getTime(totalTable[0].items[0],dif);
                    totalTable[1].items[0] = totalTable[1].items[0] + temp;
                    if (nextLine.is_paid==='1'){
                      totalTable[1].items[1] = totalTable[1].items[1] + temp;
                      totalTable[0].items[1] = this.getTime(totalTable[0].items[1],dif);
                    }
                    else{
                      totalTable[1].items[2] = totalTable[1].items[2] + temp;
                      totalTable[0].items[2] = this.getTime(totalTable[0].items[2],dif);
                    }
                  }
                }
                this.totalClocksData = {
                  "all":
                    {"time":totalTable[0].items[0],"payroll":totalTable[1].items[0]},
                  "paid":
                    {"time":totalTable[0].items[1],"payroll":totalTable[1].items[1]},
                  "unpaid":
                    {"time":totalTable[0].items[2],"payroll":totalTable[1].items[2]}
                };
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
      },
      mounted() {
        this.getProjectForFilter();
        this.getWorkingClocks();
        let date = new Date();
        this.dates.date = (date.getMonth()+1) + '/' + (date.getDate()) + '/' + date.getFullYear();
        this.dates.time.start = "07:00 am";
        this.dates.time.end   = "05:00 pm";
      }
    }
</script>

<style scoped>
  .delay{
    animation-delay: 1.0s;
  }
  .delay2{
    animation-delay: 2.0s;
  }
  .delay3{
    animation-delay: 2.0s;
  }
</style>
